import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getInstallState, installPwaListeners, requestInstallPrompt, subscribeInstallState } from '@/lib/pwa';
import { InstallPrompt } from './InstallPrompt';
import { OfflineBanner } from './OfflineBanner';
import { UpdatePrompt } from './UpdatePrompt';

/** Páginas visitadas antes de sugerir a instalação por engajamento */
const PAGES_BEFORE_INSTALL_SUGGESTION = 3;

export function PwaHost() {
  const location = useLocation();
  const visitedPagesRef = useRef(new Set<string>());
  const hasShownRef = useRef(false);

  useEffect(() => {
    installPwaListeners();
    return subscribeInstallState(() => {
      if (getInstallState().isOpen) hasShownRef.current = true;
    });
  }, []);

  // Além dos sinais de interesse (proposta, candidatura, anúncio publicado),
  // sugere instalar uma vez por sessão depois de algumas páginas visitadas.
  useEffect(() => {
    visitedPagesRef.current.add(location.pathname);
    if (hasShownRef.current || visitedPagesRef.current.size < PAGES_BEFORE_INSTALL_SUGGESTION) return;
    requestInstallPrompt('engajamento');
  }, [location.pathname]);

  return (
    <>
      <OfflineBanner />
      <UpdatePrompt />
      <InstallPrompt />
    </>
  );
}
